import React from 'react';
import { AuthObject } from '../utils/frontEndTypes';

export const AuthContext = React.createContext<Partial<AuthObject>>({});
